@if(!endedLoading){
<div class="mc-mt-100 ">
    <mi-request-submission-methods-skeleton></mi-request-submission-methods-skeleton>
</div>
}
@if(endedLoading){
<div class="mi-request-submission-methods-wrapper mc-mt-80 mc-mt-md-0" id="mi-request-submission-methods-wrapper "
    tabindex="-1" miFocusOnTab>
    <div class="mi-request-submission-methods-content">
        <div class=" d-none d-md-flex flex-column mi-equest-submission">
            <b>
                ברוכים הבאים למערכת מסלול אישי
            </b>
            <span>
                המערכת הקלה והפשוטה לבקשות אישור ליבוא אישי ממשרדי הממשלה
            </span>
        </div>
        <div class="mi-submission-methods row">
            <div class="mi-choose-authority col-12 col-xl-11" id="mi-choose-authority ">
                <span class="mi-choose-authority-title">{{requestSubmissionMethodsText?.whichOffice}}</span>
                <mc-form-field-wrapper class="col-xs-12 col-md-12 " [hideLable]="true"
                    [label]="requestSubmissionMethodsText?.whichOffice" [customErrorMessages]="customErrorMessages"
                    [fieldId]="'mi-authority-autocomplete-field'">

                    <mc-autocomplete [id]="'mi-authority-autocomplete'" [name]="'miAuthorityAutocomplete'"
                        [suggestions]="filteredAuthorities" dataKey="factorId" field="label" [dropdown]="false"
                        [forceSelection]="true" [(ngModel)]="selectedAuthority" [showSearchIcon]="true"
                        [highlightMatches]="true" (completeMethod)="searchAuthorities($event)"
                        (onSelect)="onSelectAuthority()" [required]="true">

                    </mc-autocomplete>
                </mc-form-field-wrapper>
                @if(authorityInfo?.length){
                <mc-info level="info" class="mi-info col-md-12 ">
                    <span>{{authorityInfo}}</span>
                </mc-info>
                }


            </div>
            <!-- <span class="mi-other-options ">דרכים נוספות</span>
        <div class="mi-custom-item-method" id="mi-custom-item-method">
            <mc-button imageSrc="assets/images/shared/idea.svg" label="פרט מכס / קוד הנחה"
                (click)="navigation('customItemMethod')">
                <img src="assets/images/shared/idea.svg" alt="my import">
            </mc-button>
        </div>
        -->
        </div>
        <div class="mi-request-submission-methods-navigation row mc-mt-5" id="mi-request-submission-methods-navigation">
            <mc-button [label]="genericText?.next + ' >'" class="col-md-8 col-xs-12 col-xl-4"
                (click)="navigation('approval-type-method')" [disabled]="disabledChoosApprovalType()"></mc-button>
        </div>
    </div>
    <div class=" d-none d-md-flex align-items-center"> <img
            src="assets/images/components/features/request/request-submission/request-submission-logo.svg"
            alt="my import"></div>

</div>
}

<mc-dialog [dialogProperties]="dialogProperties">
    <div class="d-flex flex-column align-items-end text-end mi-request-submission-methods-dialog">
        <b>
            {{requestSubmissionMethodsText.dialogAutorityChanged.textPart1}}
        </b>
        <span>
            {{requestSubmissionMethodsText.dialogAutorityChanged.textPart2}}</span>
    </div>

</mc-dialog>